export const LOADING = '@@common/Loading';
export const LOGIN = '@@common/Login';
export const LOGOUT = '@@common/Logout';